import React from "react";
import { Calendar as CalIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Calendar } from "./ui/calendar";

/**
 * shadcn Calendar + native time input wrapper.
 * `value` is an ISO string ("yyyy-MM-ddTHH:mm" or full ISO).
 * Emits a "yyyy-MM-ddTHH:mm" string back via onChange.
 */
function pad(n) { return String(n).padStart(2, "0"); }
function toLocalIso(d) {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export default function DateTimePicker({ value, onChange, withTime = true, "data-testid": testid }) {
  const date = value ? new Date(value) : null;
  const display = date
    ? date.toLocaleString(undefined, { month: "short", day: "numeric", year: "numeric", ...(withTime ? { hour: "2-digit", minute: "2-digit" } : {}) })
    : "Pick a date";

  const onDay = (d) => {
    if (!d) return;
    const next = date ? new Date(date) : new Date();
    next.setFullYear(d.getFullYear(), d.getMonth(), d.getDate());
    if (!withTime) { next.setHours(0, 0, 0, 0); }
    onChange(toLocalIso(next));
  };
  const onTime = (e) => {
    const [h, m] = e.target.value.split(":").map(Number);
    const next = date ? new Date(date) : new Date();
    next.setHours(h || 0, m || 0, 0, 0);
    onChange(toLocalIso(next));
  };
  const timeStr = date ? `${pad(date.getHours())}:${pad(date.getMinutes())}` : "";

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid || "datetime-picker"}
          className="pp-input flex items-center gap-2 text-start hover:border-[#00E676]/40 transition-colors"
        >
          <CalIcon size={16} className="text-[#00E676]" />
          <span className={date ? "text-white" : "text-zinc-500"}>{display}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-[#131313] border-white/10" align="start">
        <Calendar mode="single" selected={date || undefined} onSelect={onDay} className="bg-[#131313] text-white" />
        {withTime ? (
          <div className="p-3 border-t border-white/10 flex items-center gap-2">
            <input
              type="time"
              value={timeStr}
              onChange={onTime}
              data-testid={(testid || "datetime-picker") + "-time"}
              className="pp-input flex-1"
            />
          </div>
        ) : null}
      </PopoverContent>
    </Popover>
  );
}
